import {useTokenSync} from 'shared';

import {mainRequest} from '@/lib/azure';
import {setMediaToken} from '@/utils/media';

export function MediaTokenSetup(): null {
  useTokenSync(mainRequest, setMediaToken);
  return null;
}
